import { render } from "./PolicyList.vue?vue&type=template&id=3df1a32e&scoped=true"
import script from "./PolicyList.vue?vue&type=script&lang=js"
export * from "./PolicyList.vue?vue&type=script&lang=js"

import "./PolicyList.vue?vue&type=style&index=0&id=3df1a32e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3df1a32e"]])

export default __exports__